import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-panel-title',
  template: '<ng-content></ng-content>',
  styleUrls: ['./expansion.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-panel-title' },
})
export class PanelTitleComponent {}
